import React from 'react';
import classnames from 'classnames';
import { EmptyFacilities as EmptyFacilitiesIcon } from '@lt/components/icons-react/facilities';
import { useTranslation } from '@lt/localization';

import styles from './emptyFacilities.module.css';

const EmptyFacilities = ({ isMobile }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div
      className={classnames(styles.container, {
        [styles.containerMobile]: isMobile,
      })}
    >
      <EmptyFacilitiesIcon width={166} />
      <div
        className={classnames(styles.header, {
          [styles.headerMobile]: isMobile,
        })}
      >
        {t('hotel.facilities.empty.header')}
      </div>
      <div
        className={classnames(styles.text, {
          [styles.textMobile]: isMobile,
        })}
      >
        {t('hotel.facilities.empty.text')}
      </div>
    </div>
  );
};

export default EmptyFacilities;
